<template>
  <div>
   <v-row class="ma-4">
        <p>Dados Técnicos do conector</p>
      
   </v-row>
   <v-row>
      <div class="md-layout-item md-small-size-100 md-size-20">
        <md-field>
          <label>Tipo</label>
            <md-select v-model="device.connectorType" >
                <md-option value="mc4">MC4</md-option>
                 
                </md-select>
            </md-field>
      </div>

      
       <v-col cols="12" md="3">
         <v-select :disabled = "true"
          class="my-5"
          v-model="device.connectorType"
          :items="typeOptions"
          label="Tipo"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>


      </v-col>


      <br />


    </v-row>

    <!-- <div class="md-layout">
  <div class="md-layout-item md-small-size-100 md-size-20" >
                         <md-button class="md-primary" >Save</md-button>  
                     </div>
             </div> -->
  </div>
</template>



<script>
export default {
  components: {
  },

  name: "edit-connector",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
       typeOptions: [
        { value: "mc4", text: "MC4" },

      ],
      selected: [],
      optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      optionsInteger: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 0,
      },
    };
  },

  methods: {
    
    
  },
};
</script>
